import { SearchPaymentByCriteria } from '@/shared/services/payment';
import { Operations, Origin, PageInput } from '@/app/graphql/payment/sdk.payment';
import { TimeRuleDto } from '@/app/graphql/rule-engine/sdk.rule-engine';
import { PayControlKeyAvailabilityFragment } from '@/app/graphql/access-control/sdk.access-control';

export interface HistoryTransactionState {
  filter: FilterInput;
  transactions: SearchPaymentByCriteria;
  paramsPageable: PageInput;
  transactionLoading: boolean;
  transactionError: boolean;
  transactionTimeRule: Record<Operations, TimeRuleDto[]> | null;
  transactionKeyAvailability: PayControlKeyAvailabilityFragment;
  sendPayments: {
    count: number;
    countProcessed: number;
    isShowDialog: boolean;
    isSendToBank: boolean;
    text: string;
  };
}

export enum HISTORY_FILTER_STATUS {
  ALL = 'ALL',
  FOR_SIGN = 'FOR_SIGN',
  FOR_EDITING = 'FOR_EDITING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  DRAFT = 'DRAFT',
}
export interface FilterInput {
  legalPartyId: string | null;
  status: HISTORY_FILTER_STATUS;
  transferNum: string | null;
  operation: Operations | null;
  recipientName: string | null;
  startDate: string | null;
  purpose: string | null;
  endDate: string | null;
  startAmount: number;
  endAmount: number;
  creator: string | null;
  account: string | null;
  currency: { isoNum: string; isoCode: string }[] | null;
  origin: Origin | null;
  amountAsc: boolean | null;
}
export const INITIAL_FILTER_INPUT = {
  legalPartyId: null,
  status: HISTORY_FILTER_STATUS.ALL,
  transferNum: null,
  operation: null,
  recipientName: null,
  startDate: null,
  endDate: null,
  startAmount: 0,
  endAmount: 0,
  creator: null,
  account: null,
  currency: null,
  origin: null,
  amountAsc: null,
  purpose: null,
};

export const pageableHistory = { amountElements: 25, currentPage: 1 };
